/**
 * Javascript file for the page for searching for events.
 * @author Adrian Rebmann, Yannik Sprengart
 */

import {
  getEvents,
  getEventsWithFilter,
  getEventsWithinRadius
} from "../../../../api";

//Regular expression for the event dates.
const regex = new RegExp(
  "([1-9]|0[1-9]|[12][0-9]|3[01])s*([- /.])\\s*([1-9]|0[1-9]|1[012])\\s*\\2\\s*((19|20)?[0-9]{2})"
);
export default {
  name: "EventSearch",

  /**
   * The vue instance's data object.
   * @property {boolean} loading - Information is currently being processed.
   * @property {any[]} topics - The possible categories for the events.
   * @property {any[]} selectedtopics - The topics selected by the user.
   * @property {any[]} sectors - The possible sectors for the events.
   * @property {any[]} selectedsectors - The sectors selected by the user.
   * @property {any[]} processes - The possible processes for the events.
   * @property {any[]} selectedprocesses - The processes selected by the user.
   * @property {any[]} sizes - The possible sizes for the events.
   * @property {object} selectedsize - The sizes selected by the user.
   * @property {any[]} events - The available events.
   * @property {string[]} sortby - The possible options for sorting the events.
   * @property {any[]} selectedsortby - The selected sorting option by the user.
   * @property {object} plz - The city code for the event search.
   * @property {string} range - The distance range for the event search.
   * @property {any[]} searchresults - The results for the event search.
   * @property {string} msg - The name of the platform.
   * @property {string} searchterm - The term for the event search.
   * @property {object} searchoptions - Search parameters for VueFuse. For more details, check: https://www.npmjs.com/package/vue-fuse/v/1.5.2
   * @property {string[]} searchoptions.keys - The key values for the search.
   */
  data() {
    return {
      loading: false,
      topics: [
        {
          index: 0,
          text: "Additive Fertigungsverfahren",
          name: "additive-fertigungsverfahren"
        },
        { index: 1, text: "Assistenzsysteme", name: "assistenzsysteme" },
        { index: 2, text: "Cloud-Anwendungen", name: "cloud-anwendungen" },
        { index: 3, text: "Digitale Bildung", name: "digitale-bildung" },
        {
          index: 4,
          text: "Digitale Geschäftsmodelle",
          name: "digitale-geschaeftsmodelle"
        },
        { index: 5, text: "eBusiness-Standards", name: "ebusiness-standards" },
        {
          index: 6,
          text: "Elektronischer Zahlungsverkehr",
          name: "elektronischer-zahlungsverkehr"
        },
        { index: 7, text: "Handel", name: "handel" },
        {
          index: 8,
          text: "Informations- und Planungssysteme",
          name: "informations-planungssysteme"
        },
        { index: 9, text: "IT-Sicherheit", name: "it-sicherheit" },
        {
          index: 10,
          text: "Kommunikation digitalisieren",
          name: "kommunikation-digitalisieren"
        },
        { index: 11, text: "Kundenbeziehungen", name: "kundenbeziehungen" },
        { index: 12, text: "Digitales Arbeiten", name: "digitales-arbeiten" },
        {
          index: 13,
          text: "Unternehmensprozesse",
          name: "unternehmensprozesse"
        },
        {
          index: 14,
          text: "Usability und User Experience",
          name: "usability-user-experience"
        },
        {
          index: 15,
          text: "Veränderungsmanagement",
          name: "veraenderungsmanagement"
        },
        {
          index: 16,
          text: "Vernetzte Produktion",
          name: "vernetzte-produktion"
        },
        {
          index: 17,
          text: "Vernetzte Wertschöpfungskette",
          name: "vernetzte-wertschoepfungskette"
        }
      ],
      selectedtopics: [],
      sectors: [
        {
          text: "Land- & Forstwirtschaft, Fischerei",
          name: "landwirtschaft-forstwirtschaft-fischerei"
        },
        {
          text: "Industrie, Verarbeitendes Gewerbe",
          name: "industrie-verarbeitendes-gewerbe"
        },
        { text: "Energie, Handwerk und Bauen", name: "energie-handwerk-bauen" },
        { text: "Dienstleistungen", name: "dienstleistungen" },
        {
          text: "Handel (Binnenhandel, Gastgewerbe, Tourismus)",
          name: "handel_binnenhandel"
        },
        { text: "Logistik (Transport & Verkehr)", name: "logistik_transport" }
      ],
      selectedsectors: [],
      processes: [
        { text: "Produktentwicklung", name: "produktentwicklung" },
        { text: "Beschaffung und Einkauf", name: "beschaffung" },
        {
          text: "Planung & Steuerung von Produktionsabläufen",
          name: "planung-steuerung"
        },
        { text: "Marketing und Kundenbindung", name: "marketing" },
        { text: "Vertrieb", name: "vertrieb" },
        { text: "Logistik", name: "logistik" },
        {
          text: "Innerbetriebliche Verwaltung",
          name: "innerbetriebliche-verwaltung"
        }
      ],
      selectedprocesses: [],
      sizes: [
        { text: "Alle", name: "alle" },
        {
          text: "Kleinstunternehmen (< 10 Beschäftigte)",
          name: "kleinstunternehmen"
        },
        {
          text: "Kleine Unternehmen (< 50 Beschäftigte)",
          name: "kleine-unternehmen"
        },
        {
          text: "Mittlere Unternehmen (< 250 Beschäftigte)",
          name: "mittlere-unternehmen"
        }
      ],
      selectedsize: null,
      events: [],
      sortby: ["Datum aufsteigend", "Datum absteigend"],
      selectedsortby: [],
      plz: null,
      range: "",
      searchresults: [],
      msg: "WERNER",
      searchterm: "",
      searchoptions: {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["name", "description", "category"]
      }
    };
  },

  /**
   * Called after the instance has been mounted. 
   */
  mounted() {
    this.loading = true;
    this.selectedsize = this.sizes[0].text;
    if (localStorage.getItem("selectedprocesses") !== null) {
      this.selectedprocesses = JSON.parse(
        window.localStorage.getItem("selectedprocesses")
      );
      this.selectedtopics = JSON.parse(
        window.localStorage.getItem("selectedtopics")
      );
      this.selectedsectors = JSON.parse(
        window.localStorage.getItem("selectedsectors")
      );
      this.selectedsize = JSON.parse(
        window.localStorage.getItem("selectedsize")
      );
    }
    if (
      this.selectedprocesses.length > 0 ||
      this.selectedsectors.length > 0 ||
      this.selectedsize != "Alle" ||
      this.selectedtopics.length > 0
    ) {
      this.applyFilters();
    } else {
      getEvents()
        .then(res => {
          let sorted = res.sort(function (a, b) {
            let parts_a = a.eventdate.match(regex);
            let parts_b = b.eventdate.match(regex);
            let date_b = parts_b[4] + "-" + parts_b[3] + "-" + parts_b[1];
            let date_a = parts_a[4] + "-" + parts_a[3] + "-" + parts_a[1];
            return new Date(date_a) - new Date(date_b);
          });
          this.events = sorted;
          this.searchresults = sorted;
          this.loading = false;
        })
        .catch(err => {
          //console.log(err);
          this.loading = false;
        });
    }
  },

  /**
   * Expressions to be watched.
   */
  watch: {
    searchterm: function () {
      if (this.searchterm != "") {
        this.search();
      } else {
        this.searchresults = this.events.sort(function (a, b) {
          let parts_a = a.eventdate.match(regex);
          let parts_b = b.eventdate.match(regex);
          let date_b = parts_b[4] + "-" + parts_b[3] + "-" + parts_b[1];
          let date_a = parts_a[4] + "-" + parts_a[3] + "-" + parts_a[1];
          return new Date(date_a) - new Date(date_b);
        });
      }
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Returns to the previously visited page. 
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Conducts an event search based on the search term and the search options.
     */
    search() {
      this.$search(this.searchterm, this.events, this.searchoptions).then(
        results => {
          this.searchresults = results;
        }
      );
    },

    /**
     * Shortens the description.
     * @param {*} desc - The description. 
     * @returns - The resulting string.
     */
    shorten(desc) {
      var res = desc.substring(0, 500) + "...";
      return res;
    },

    /**
     * Removes a topic from the list of selected topics.
     * @param {*} string - The name of the topic to be removed.
     */
    removeTopic(string) {
      for (let i = 0; i < this.selectedtopics.length; i++) {
        if (this.selectedtopics[i] == string) this.selectedtopics.splice(i, 1);
      }
    },

    /**
     * Removes a sector from the list of selected sectors.
     * @param {*} string - The name of the sector to be removed.
     */
    removeSector(string) {
      for (let i = 0; i < this.selectedsectors.length; i++) {
        if (this.selectedsectors[i] == string)
          this.selectedsectors.splice(i, 1);
      }
    },

    /**
     * Removes a process from the list of selected processes.
     * @param {*} string - The name of the process to be removed.
     */
    removeProcess(string) {
      for (let i = 0; i < this.selectedprocesses.length; i++) {
        if (this.selectedprocesses[i] == string)
          this.selectedprocesses.splice(i, 1);
      }
    },

    /**
     * Applies to the events shown in the page.
     */
    applyFilters() {
      this.loading = true;
      window.localStorage.setItem(
        "selectedprocesses",
        JSON.stringify(this.selectedprocesses)
      );
      window.localStorage.setItem(
        "selectedtopics",
        JSON.stringify(this.selectedtopics)
      );
      window.localStorage.setItem(
        "selectedsectors",
        JSON.stringify(this.selectedsectors)
      );
      window.localStorage.setItem(
        "selectedsize",
        JSON.stringify(this.selectedsize)
      );
      let filter = [];

      //Selected topics
      for (let i = 0; i < this.selectedtopics.length; i++) {
        for (let j = 0; j < this.topics.length; j++) {
          if (this.topics[j].text == this.selectedtopics[i])
            filter.push({ name: this.topics[j].name, type: "themen" });
        }
      }

      //Selected processes
      for (let i = 0; i < this.selectedprocesses.length; i++) {
        for (let j = 0; j < this.processes.length; j++) {
          if (this.processes[j].text == this.selectedprocesses[i])
            filter.push({
              name: this.processes[j].name,
              type: "cl2RelatedEnts_Unternehmenprozesse"
            });
        }
      }

      //Selected sectors
      for (let i = 0; i < this.selectedsectors.length; i++) {
        for (let j = 0; j < this.sectors.length; j++) {
          if (this.sectors[j].text == this.selectedsectors[i])
            filter.push({
              name: this.sectors[j].name,
              type: "cl2RelatedEnts_Branchen"
            });
        }
      }

      if (this.selectedsize != "Alle") {
        filter.push({
          name: this.selectedsize,
          type: "cl2RelatedEnts_Unternehmengroesse"
        });
      }
      if (
        filter.length > 0 &&
        this.plz != null &&
        this.plz.length == 5 &&
        this.range != ""
      ) {
        getEventsWithinRadius(this.range, this.plz).then(res1 => {
          getEventsWithFilter(filter)
            .then(res => {
              let final = [];
              for (let i = 0; i < res.length; i++) {
                for (let j = 0; j < res1.length; j++) {
                  if (res[i].hash == res1[j].hash) {
                    final.push(res[i]);
                  }
                }
              }
              let sorted = final.sort(function (a, b) {
                let parts_a = a.eventdate.match(regex);
                let parts_b = b.eventdate.match(regex);
                let date_b = parts_b[4] + "-" + parts_b[3] + "-" + parts_b[1];
                let date_a = parts_a[4] + "-" + parts_a[3] + "-" + parts_a[1];
                return new Date(date_a) - new Date(date_b);
              });
              this.events = sorted;
              this.searchresults = sorted;
              this.loading = false;
            })
            .catch(err => {
              //console.log(err);
              this.loading = false;
            });
        });
      } else if (filter.length > 0) {
        getEventsWithFilter(filter)
          .then(res => {
            let sorted = res.sort(function (a, b) {
              let parts_a = a.eventdate.match(regex);
              let parts_b = b.eventdate.match(regex);
              let date_b = parts_b[4] + "-" + parts_b[3] + "-" + parts_b[1];
              let date_a = parts_a[4] + "-" + parts_a[3] + "-" + parts_a[1];
              return new Date(date_a) - new Date(date_b);
            });
            this.events = sorted;
            this.searchresults = sorted;
            this.loading = false;
          })
          .catch(err => {
            //console.log(err);
            this.loading = false;
          });
      } else if (this.range != "" && this.plz != null && this.plz.length == 5) {
        getEventsWithinRadius(this.range, this.plz).then(res1 => {
          let sorted = res1.sort(function (a, b) {
            let parts_a = a.eventdate.match(regex);
            let parts_b = b.eventdate.match(regex);
            let date_b = parts_b[4] + "-" + parts_b[3] + "-" + parts_b[1];
            let date_a = parts_a[4] + "-" + parts_a[3] + "-" + parts_a[1];
            return new Date(date_a) - new Date(date_b);
          });
          this.events = sorted;
          this.searchresults = sorted;
          this.loading = false;
        });
      } else {
        getEvents()
          .then(res => {
            let sorted = res.sort(function (a, b) {
              let parts_a = a.eventdate.match(regex);
              let parts_b = b.eventdate.match(regex);
              let date_b = parts_b[4] + "-" + parts_b[3] + "-" + parts_b[1];
              let date_a = parts_a[4] + "-" + parts_a[3] + "-" + parts_a[1];
              return new Date(date_a) - new Date(date_b);
            });
            this.events = sorted;
            this.searchresults = sorted;
            this.loading = false;
          })
          .catch(err => {
            //console.log(err);
            this.loading = false;
          });
      }
    },

    /**
     * Resets the filters for the events shown in the page.
     */
    resetFilters() {
      this.loading = true;
      window.localStorage.removeItem("selectedprocesses");
      window.localStorage.removeItem("selectedtopics");
      window.localStorage.removeItem("selectedsectors");
      window.localStorage.removeItem("selectedsize");
      this.selectedprocesses = [];
      this.selectedsectors = [];
      this.selectedsize = this.sizes[0].text;
      this.selectedtopics = [];
      this.range = "";
      this.plz = null;
      getEvents()
        .then(res => {
          let sorted = res.sort(function (a, b) {
            let parts_a = a.eventdate.match(regex);
            let parts_b = b.eventdate.match(regex);
            let date_b = parts_b[4] + "-" + parts_b[3] + "-" + parts_b[1];
            let date_a = parts_a[4] + "-" + parts_a[3] + "-" + parts_a[1];
            return new Date(date_a) - new Date(date_b);
          });
          this.loading = false;
          this.events = sorted;
          this.searchresults = sorted;
        })
        .catch(err => {
          //console.log(err);
          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/search/eventsearch/query/eventsearch.js